import axios from 'axios'
import _ from 'lodash'
import moment from 'moment'

// state
const state = {
	dataForServer: {},
	cancelLoader: false,
	canCancel: false,
	cancelConfirmMessage: '',
	cancelSuccessMessage: '',
	// incremented when a cancel is requested; components watch it instead of
	// relying on the old global event bus
	cancelRequestedTick: 0,
}

const getters = {
}


// mutations
const mutations = {
	TOGGLE_BOOLEAN_STATE(state, { key, bool }) {
		eval('state.' + key + ' = bool');
	},

	SET_DATA_FOR_SERVER(state, { serverData }) {
		state.dataForServer = serverData
	},

	UPDATE_SELECTED_DATA(state, { key, value }) {
		// append/update dataForServer
		state.dataForServer[key] = value;
	},

	SET_MESSAGE(state, { key, message }) {
		eval('state.' + key + ' = message');
	},
}

// actions
const actions = {
	setShowButton({ commit }, { key, bool }) {
		commit('TOGGLE_BOOLEAN_STATE', { key: key, bool: bool });
	},

	/**
	 * prepopulate dataForServer container with all required fields
	 * use client_request_id to update all requests with this id in request table.
	 */
	setDataForServer({ commit, state, dispatch, rootState }) {
		// gather all required data for inserting into request_cancels table.
		var selectedData = rootState.requests.formData[0];
		var user = rootState.auth.user;

		// var serverData = {
		// 	cancel_type_id: 1,  // Default to Early Cancel for now. We'll determien if it's late when it's being submitted
		// 	method_id: 7,  // 7 - online
		// 	request_id: selectedData.request_id,
		// 	client_request_id: selectedData.id,
		// 	cancelled_by: user.full_name,
		// 	cancel_date: moment().format('MM-DD-YYYY'),
		// 	cancel_time: moment().format('hh:mm:ss A'),

		// };

		var serverData = {
			cancel_date: moment().format('MM-DD-YYYY'),
			cancel_method_id: 7,  // 7 - online
			cancel_name: user.full_name,
			cancel_time: moment().format('hh:mm:ss A'),
			cancel_type_id: 8, // 8 = Client Portal
			client_request_id: selectedData.id,
			remark_type_id: 2 // 2 = Job Cancelled
		};

		var confirmMessage = 'Are you sure you want to cancel request <u>#' + selectedData.job_no + '</u>?';
		var successMessage = 'Request <u>#' + selectedData.job_no + '</u> has been cancelled.';
		//console.log(message);
		commit('SET_MESSAGE', { key: 'cancelConfirmMessage', message: confirmMessage })
		commit('SET_MESSAGE', { key: 'cancelSuccessMessage', message: successMessage })
		commit('SET_DATA_FOR_SERVER', { serverData })
	},

	updateSelectedData({ commit, state, dispatch }, key, value) {
		commit('UPDATE_SELECTED_DATA', key, value)
	},

	// check before closing cancellation
	checkBeforeLeaving({ commit, state, dispatch }) {
		var isCancel = state.canCancel;
		var haveNotes = state.dataForServer.cancel_notes;
		// show Cancellation Not Save when message is entered in textarea
		if (isCancel == true && typeof haveNotes !== 'undefined') {
			VueStore.dispatch('notify/setShowMessage', { key: 'showCancelRequestNotSaved', bool: true });
			// hide cancel request textarea and show options button
		} else {
			dispatch('closeCancellation');
		}
	},

	/*	checkBeforeSubmitCancel({commit, state, rootState, dispatch}){
			var currentData = rootState.requests.formData[0];
			var dateTime = currentData.service_date + ' '+currentData.service_time;
			var serviceDate = moment(dateTime).format('MM-DD-YYYY HH:mm');
			var currentDate = moment().format('MM-DD-YYYY HH:mm');
	
			//var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
			var hours = 60*60*1000; // hours*minutes*seconds*milliseconds
			var firstDate = new Date(currentDate);
			var secondDate = new Date(serviceDate);
	
			//console.log(firstDate.getTime());
			//console.log(secondDate.getTime());
	
			var diffHours = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime())/(hours)))
	
			//console.log(diffHours);
	
			if(diffHours <= 24){
						// show last minute cancellation modal 
						VueStore.dispatch('notify/setShowMessage', {key: 'showLastMinuteCancel', bool: true});
			}else {
						// show cancel confirmation modal 
						VueStore.dispatch('notify/setShowMessage', {key: 'showCancelRequestConfirm', bool: true});
				}
		},,*/

	checkLastMinuteCancel({ commit, state, rootState, dispatch }) {
		var currentData = rootState.requests.formData[0];
		var dateTime = currentData.service_date + ' ' + currentData.service_time;
		var serviceDate = moment(dateTime).format('MM-DD-YYYY HH:mm');
		var currentDate = moment().format('MM-DD-YYYY HH:mm');

		//var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
		var hours = 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
		var firstDate = new Date(currentDate);
		var secondDate = new Date(serviceDate);

		//console.log(firstDate.getTime());
		//console.log(secondDate.getTime());

		var diffHours = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (hours)))

		//console.log(diffHours);

		if (diffHours <= 24) {
			// show last minute cancellation modal 
			VueStore.dispatch('notify/setShowMessage', { key: 'showLastMinuteCancel', bool: true });
		} else {
			// show cancel confirmation modal 
			//VueStore.dispatch('notify/setShowMessage', {key: 'showCancelRequestConfirm', bool: true});
			state.cancelRequestedTick++;
			//console.log("Cancel Request");
			// show cancellation buttons
			VueStore.dispatch('nav/setVariables',
				{
					key: 'activeInfoButton',
					value: 'cancel'
				}
			)
			// auto-populate cancel fields
			VueStore.dispatch('cancelRequest/setDataForServer');
			VueStore.dispatch('nav/setVariables', { key: 'newRequestSelected', value: true }); // disable New Request button

		}
	},

	/*
	 * Per request by Mandi (9/10/2018)
	 * Removed 24 hours restriction.
	 * Client can cancel anytime before service date and time.
	 */
	setupCancellation({ commit, state, rootState, dispatch }) {
		//console.log("setupCancellation")
		state.cancelRequestedTick++;
		VueStore.dispatch('nav/setVariables',
			{
				key: 'activeInfoButton',
				value: 'cancel'
			}
		)
		// auto-populate cancel fields
		VueStore.dispatch('cancelRequest/setDataForServer');
		VueStore.dispatch('nav/setVariables', { key: 'newRequestSelected', value: true }); // disable New Request button
	},

	// close Cancellation
	closeCancellation({ commit, state, dispatch }) {
		$('.cancel-request-overlay').fadeOut('fast');
		VueStore.dispatch('nav/setVariables',
			{
				key: 'activeInfoButton',
				value: 'cancel'
			}
		)
		VueStore.dispatch('nav/setVariables', { key: 'newRequestSelected', value: false }); // disable New Request button
		// clear data for server vuex
		dispatch('clear');
	},

	submitCancelRequestToServer({ commit, state, dispatch, rootState }) {
		//set loader
		//dispatch('setShowButton', {key: 'cancelLoader', bool: true});
		commit('TOGGLE_BOOLEAN_STATE', { key: 'cancelLoader', bool: true });

		//var url = rootState.auth.l+'v1/request-cancels';
		var url = rootState.auth.l + 'v1/request-remarks';
		var dataForServer = state.dataForServer;
		var client_request_id = dataForServer.client_request_id;

		$.ajax({
			url: url,
			data: dataForServer,
			type: 'POST',
			beforeSend: function (xhr) { xhr.setRequestHeader('Authorization', 'Bearer ' + rootState.auth.a); },
			success: function (response) {
				VueStore.dispatch('notify/setShowMessage', { key: 'showCancelRequestSuccess', bool: true });
				commit('TOGGLE_BOOLEAN_STATE', { key: 'cancelLoader', bool: false });
				commit('TOGGLE_BOOLEAN_STATE', { key: 'canCancel', bool: false });
				//console.log(response);
				var newData = response.data[0];
				//VueStore.dispatch('requests/setFormDataAfterCancel', newData);

				// Retrieve data again because status has changed.
				VueStore.dispatch('requests/setFormDataAfterCancel', client_request_id);

				// Also remarks can have multiple rows but we
				// only want notes coming from client portal.
				VueStore.dispatch('requests/getRemarks', client_request_id);

				//show options button
				VueStore.dispatch('nav/setVariables',
					{
						key: 'activeInfoButton',
						value: 'options'
					}
				)
				VueStore.dispatch('nav/setVariables', { key: 'newRequestSelected', value: false }); // enable New Request button

				$('.cancel-request-overlay').fadeOut('fast');
			},
			error: function (xhr, ajaxOptions, error) {
				//dispatch('auth/checkErrorAjax', xhr, {root: true})
				console.log(xhr);
			}
		});

		// setTimeout(function(){

		// 	VueStore.dispatch('cancelRequest/setShowButton', {key: 'cancelLoader', bool: false});

		// }, 3000);
	},

	clear({ commit }) {
		var empty = {};

		commit('SET_DATA_FOR_SERVER', { serverData: empty });
		commit('TOGGLE_BOOLEAN_STATE', { key: 'canCancel', bool: false });
	},

}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}